import React from "react";
import { Container } from '@mui/material';

const DarjeelingCreateEditForm = () => {
    
    return (
        <Container>
            <h1>Darjeeling</h1>
        </Container>
    );
}
  
export default DarjeelingCreateEditForm;